import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack, useTheme, Typography, Button } from '@mui/material';

import { FindRecipeMockData } from '@app/fixtures/find-recipe-mock-data';
import useResponsive from '@app/hooks/use-responsive';
import { SearchBar } from '@app/components';
import { Strings } from '@app/constants';
import { SelectIngredientsScreen } from '@app/modules/select-ingredients';
import { PATH_DASHBOARD } from '@app/routes/paths';

const FindARecipeScreen = () => {
  const theme = useTheme();
  const navigation = useNavigate();
  const isMobile = useResponsive('up', 'sm');

  const [openDrawer, setOpenDrawer] = useState<any>(false);

  return (
    <Stack>
      <SearchBar
        inputProps={{ readOnly: true }}
        onClick={() => navigation(PATH_DASHBOARD.searchScreen)}
        sx={{
          backgroundColor: theme.palette.primary.light,
          borderRadius: '50px',
          color: theme.palette.tertiary.shadyText,
          width: isMobile ? '60%' : '100%',
          height: '52px',
        }}
        placeholder={Strings.field.searchDishes}
      />
      <Stack
        sx={{
          flexWrap: 'wrap',
          flexDirection: 'row',
          mt: 2,
          gap: 3,
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {FindRecipeMockData?.map((item, index) => (
          <Stack
            key={index}
            sx={{
              background: {
                xs: `url(/assets/background/find-recipe-bg.png) center/cover`,
                width: isMobile ? '45%' : '100%',
                borderRadius: '10px',
                height: 170,
              },
            }}
          >
            <Typography variant="h4" sx={{ m: 5, color: '#ffff' }}>
              {item?.name}
            </Typography>
            <Button
              onClick={() =>
                setOpenDrawer({
                  mealType: item.value,
                  dishType: item.dishType,
                  title: item.name,
                })
              }
              sx={{ bgcolor: '#ffff', width: '40%', alignSelf: 'flex-end', mb: 5, mr: 5 }}
            >
              {Strings.button.getStarted}
            </Button>
          </Stack>
        ))}
      </Stack>
      <SelectIngredientsScreen openNav={openDrawer} onCloseNav={() => setOpenDrawer(false)} />
    </Stack>
  );
};

export { FindARecipeScreen };
